module.exports = __webpack_public_path__ + "img/logo-branco.3b471d2a.png";